import styled from "styled-components";
const Button = styled.button`
  /* border: 2px solid black; */
  border-style: none;
  margin: 0.2rem;
  &:active:hover {
    box-shadow: 0 0;
  }
  box-shadow: 0.1rem 0.1rem #aaa;
  width: 100%;
  padding: 0.3rem;
`;

export const PrimaryButton = styled(Button)`
  color: #efe;
  background: #080;
  border: 1px solid #121;
  box-shadow: 0.1rem 0.1rem #050;
`;

export const SecondaryButton = styled(Button)`
  color: #eee;
  background: #555;
  border: 1px solid #121;
  box-shadow: 0.1rem 0.1rem #333;
`;

export const WarningButton = styled(Button)`
  color: #fee;
  background: #800;
  border: 1px solid #121;
  box-shadow: 0.1rem 0.1rem #500;
`;
